import { Select } from 'components/Select/Select'
import { Item } from '@react-stately/collections'
import Styles from './StrategyAndContextSelection.module.scss'
import { SelectProps } from '@react-types/select'
import { ButtonProps } from 'blaze-ui/Button/Types'
import { BrandPlan, ContentStrategyType } from 'types'
import { ContentStrategyTypeEmoji } from 'components/ContentStrategyTypeEmoji/ContentStrategyTypeEmoji'
import { ContentStrategyTypeLabel } from '../../../constants'
import { ContentStrategyTypeShortDescription } from '../../../constants'

export interface StrategySelectProps<T extends string | object>
  extends Omit<SelectProps<T>, 'children'>,
    Pick<ButtonProps, 'size' | 'variant'> {
  brandPlan: BrandPlan
  readonly?: boolean
}

export const StrategySelect = <T extends object>({
  brandPlan,
  readonly,
  selectedKey,
  ...props
}: StrategySelectProps<T>) => {
  if (readonly) {
    return (
      <div className={Styles.readonlyContainer}>
        <ContentStrategyTypeEmoji contentStrategyType={selectedKey as ContentStrategyType} />
        {ContentStrategyTypeLabel[selectedKey as ContentStrategyType]} -{' '}
        {ContentStrategyTypeShortDescription[selectedKey as ContentStrategyType]}
      </div>
    )
  }
  return (
    <Select
      {...props}
      popoverClass={Styles.container}
      selectedKey={selectedKey}
      variant="secondary"
      size="lg"
      spanClass={Styles.spanClass}
      aria-label="Select content type"
    >
      {Object.keys(brandPlan.content_strategies ?? {}).map((key) => (
        <Item key={key} textValue={key}>
          <ContentStrategyTypeEmoji contentStrategyType={key as ContentStrategyType} />{' '}
          <div className={Styles.strategyLabel}>
            {ContentStrategyTypeLabel[key as ContentStrategyType]} -{' '}
            {ContentStrategyTypeShortDescription[key as ContentStrategyType]}
          </div>
        </Item>
      ))}
    </Select>
  )
}
